export default class NoConnectionError extends Error {}
